/** @format */
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

const icons = Object.keys(ElementPlusIconsVue);

export default [
	{
		key: 'Local',
		icon: ['menu-cricle'],
	},
	{
		key: 'System',
		icon: [
			'House',
			'Setting',
			'Discount',
			'Message',
			'Operation',
			'Open',
			'UserFilled',
			'Tools',
			'HomeFilled',
			'Menu',
			'UploadFilled',
		],
	},
	{
		key: 'Document',
		icon: [
			'DocumentAdd',
			'Document',
			'Notebook',
			'Tickets',
			'Memo',
			'Collection',
			'ScaleToOriginal',
			'SetUp',
			'DocumentDelete',
			'DocumentChecked',
			'DataBoard',
		],
	},
	{
		key: 'Other',
		icon: [...icons],
	},
];
